import { Btn, SHELL, Reveal, Mono } from "@/components/bits";

export default function FinalMessage() {
    return (
        <section className="relative py-28 md:py-44 overflow-hidden border-t border-white/10" data-testid="final-message-section">
            <div className="absolute inset-0 vera-grid-bg" aria-hidden="true" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[500px] rounded-full bg-vera-blue/10 blur-[130px]" aria-hidden="true" />
            <SHELL className="relative text-center">
                <Reveal>
                    <Mono className="text-vera-gold">09 — THE ROAD AHEAD</Mono>
                </Reveal>
                <h2 className="mt-10 text-4xl sm:text-6xl lg:text-7xl font-black tracking-tight leading-[1.02]">
                    <Reveal delay={0.05}>
                        <span className="block">THE WORLD ALREADY</span>
                    </Reveal>
                    <Reveal delay={0.12}>
                        <span className="block">HAS THE ASSETS.</span>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <span className="block text-gold-grad">VERA BUILDS THE</span>
                    </Reveal>
                    <Reveal delay={0.28}>
                        <span className="block text-gold-grad">CAPITAL LAYER.</span>
                    </Reveal>
                </h2>
                <Reveal delay={0.36}>
                    <p className="mt-10 font-mono text-[11px] sm:text-xs tracking-[0.4em] text-vera-mut">REAL ASSETS. PROGRAMMABLE CAPITAL.</p>
                </Reveal>
                <Reveal delay={0.44}>
                    <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
                        <Btn variant="blue" to="/assets" testid="final-cta-explore">EXPLORE VERA</Btn>
                        <Btn variant="ghost" to="/article" testid="final-cta-thesis">READ THE THESIS</Btn>
                        <Btn variant="gold" to="/proof" testid="final-cta-proof">VERIFY THE SOURCES</Btn>
                    </div>
                </Reveal>
            </SHELL>
        </section>
    );
}
